import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import '../Footer/Footer.css'
import environment from "../../environment/environment";
import footerImage from '../../assets/images/footerImage.webp';

const Footer = () => {
    const [tripTypeDetails, setTripTypeDetails] = useState({
        internationalList: [],
        domesticList: [],
        weekendList: [],
        groupList: [],
        honeymoonList: [],
    });

    useEffect(() => {
        getAllTripType();
    }, []);

    const getAllTripType = () => {
        axios({
            url: `${environment.config.apiBaseUrl}route/getAllTripType`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    setTripTypeDetails(res.data);
                }
            })
            .catch((err) => {
                console.error("Error fetching trip types:", err);
            });
    };

    const organizeRoutesByName = (routeList) => {
        if (!routeList || routeList.length === 0) return [[], [], []];
        const uniqueRoutes = [];
        const seenNames = new Set();

        routeList.forEach((route) => {
            if (!seenNames.has(route.routeName)) {
                seenNames.add(route.routeName);
                uniqueRoutes.push({
                    name: route.routeName,
                    id: route.routeId,
                });
            }
        });

        const columns = [[], [], []];
        uniqueRoutes.forEach((route, index) => {
            columns[index % 3].push(route);
        });
        return columns;
    };

    const navItems = [
        {
            label: "Group Trips",
            options:
                tripTypeDetails.groupList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.groupList)
                    : [[{ name: "No packages available", id: null }]],
            key: "group",
        },
        {
            label: "Domestic Packages",
            options:
                tripTypeDetails.domesticList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.domesticList)
                    : [[{ name: "No packages available", id: null }]],
            key: "domestic",
        },
        {
            label: "Couple Special",
            options:
                tripTypeDetails.honeymoonList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.honeymoonList)
                    : [[{ name: "No packages available", id: null }]],
            key: "honeymoon",
        },
        {
            label: "International Packages",
            options:
                tripTypeDetails.internationalList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.internationalList)
                    : [[{ name: "No packages available", id: null }]],
            key: "international",
        },
        {
            label: "Customized Trips",
            options:
                tripTypeDetails.weekendList?.length > 0
                    ? organizeRoutesByName(tripTypeDetails.weekendList)
                    : [[{ name: "No packages available", id: null }]],
            key: "weekend",
        },
    ];

    return (
        <footer className="text-center text-lg-start bg-body-tertiary text-muted footer-container-fluid">
            <section className="d-flex justify-content-center justify-content-lg-between p-4">
                <div className="container text-center text-md-start mt-3">
                    <div className="row mt-2">
                        {navItems.map((item, index) => (
                            <div key={index} className="col-6 col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
                                <h6 className="fw-bold mb-4 footer-title text-start">{item.label}</h6>
                                {item.options.map((col, i) => (
                                    <div key={i}>
                                        {col.map((route, j) =>
                                            route.id ? (
                                                <Link
                                                    key={j}
                                                    style={{
                                                        color: "#fff099",
                                                        textDecoration: "none",
                                                        textAlign: 'left'
                                                    }}
                                                    to={`/tour/${route.id}`}
                                                    target="_blank"
                                                >
                                                    <p>{route.name}</p>
                                                </Link>
                                            ) : (
                                                <p key={j}>{route.name}</p>
                                            )
                                        )}
                                    </div>
                                ))}
                            </div>
                        ))}

                        <div className="col-6 col-md-2 col-lg-2 col-xl-2 mx-auto mb-4 text-start">
                            <h6 className="fw-bold mb-4 footer-title">Quick Links</h6>
                            <div>
                                <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/about-us"
                                >
                                    <p>About Us</p>
                                </Link>
                                {/* <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/blog"
                                >
                                    <p>Blogs</p>
                                </Link> */}
                                <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/privacy-policy"
                                >
                                    <p>Privacy Policy</p>
                                </Link>
                                <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/cancellation-policy"
                                >
                                    <p>Cancellation Policy</p>
                                </Link>
                                <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/terms-and-conditions"
                                >
                                    <p>Terms & Conditions</p>
                                </Link>
                                {/* <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/disclaimer"
                                >
                                    <p>Disclaimer</p>
                                </Link> */}
                                {/* <Link
                                    style={{
                                        color: "#fff099",
                                        textDecoration: "none",
                                    }}
                                    to="/payment-policy"
                                >
                                    <p>Payment Policies</p>
                                </Link> */}

                            </div>
                        </div>

                        <div className="footer__divider_line"></div>
                        <div className="row d-flex text-md-center mt-4">
                            <p className='companyTitle'><i className="fas fa-home me-3"></i>Ghoomo World Private Ltd.</p>
                            <p className='company-address'><i className="fas fa-envelope me-3 "></i>Office No F-179, Fantasia Business Park, Sector 30A, Vashi, Navi Mumbai, Maharashtra 400703</p>
                            <div className='d-flex flex-row justify-content-center company-address'>
                                <p className='me-4'><i className="fas fa-phone "></i> +91-1234567890</p>
                                <p><i className="fas fa-phone "></i> +91-1234567890 </p>
                            </div>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <img className='footer-img' src={footerImage} alt='footerimg' />
                        </div>
                    </div>
                </div>
            </section>
            <div className="footer__divider_line"></div>
            <div className="copyright-content">
                <div className="text-center company-address" style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
                    © 2024 Copyright (V 1.1.15)
                    <a className="text-reset fw-bold footer-links" href="https://www.divandsection.com/"> Divandsection.com</a>
                </div>
                <div className='d-flex align-items-center company-address'>
                    <a className="me-4 text-reset">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <a className="me-4 text-reset">
                        <i className="fab fa-twitter"></i>
                    </a>
                    <a className="me-4 text-reset">
                        <i className="fab fa-google"></i>
                    </a>
                    <a className="me-4 text-reset">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a className="me-4 text-reset">
                        <i className="fab fa-linkedin"></i>
                    </a>
                    <a className="me-4 text-reset">
                        <i className="fab fa-github"></i>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;